import { render, staticRenderFns } from "./JobRequestNotes.vue?vue&type=template&id=73cd124b&"
import script from "./JobRequestNotes.vue?vue&type=script&lang=js&"
export * from "./JobRequestNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports